module.exports = __webpack_public_path__ + "static/media/aman-jaiswal.7bce0d42.jpg";